type ListType = 'conjunction' | 'disjunction';

const cache = new Map<string, Intl.ListFormat>();

const formatterFor = (locale: string, type: ListType): Intl.ListFormat => {
  const key = `${locale}|${type}`;
  const cached = cache.get(key);
  if (cached) return cached;
  let formatter: Intl.ListFormat;
  try {
    formatter = new Intl.ListFormat(locale, { style: 'long', type });
  } catch {
    formatter = new Intl.ListFormat('en', { style: 'long', type });
  }
  cache.set(key, formatter);
  return formatter;
};

export const formatNameList = (names: readonly string[], locale: string): string =>
  formatterFor(locale, 'conjunction').format(names);

export const formatChoiceList = (choices: readonly string[], locale: string): string =>
  formatterFor(locale, 'disjunction').format(choices);
